import React from 'react'

export default props => (
	<button type={'button'} className={`btn btn-flat ${props.small ? 'btn-xs' : ''} btn-outline-${props.type}`}
		onClick={props.event} disabled={props.disabled}
		title={props.title || ''}
		style={{ ...props.style, visibility: props.visible ? 'visible' : 'collapse' }}>
		<i className={props.icon}></i>
	</button>
)

/*
primary
secondary
success
danger
warning
info
light
dark
link
*/
